import { useParams } from 'react-router-dom'

export const useFollowupIdFromParams = (): number => {
  const params = useParams()
  return Number.parseInt(params.followupId as string)
}
